import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tsv2-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
